import { useContext, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Typography, MenuItem, TextField as MuiTextField } from '@mui/material';
import { orderContext, orderSchema } from '../OrderContext';
import * as yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { TextField, Autocomplete } from 'formik-mui';
import { applicationContext } from 'helpers/services';
import theme from 'assets';
import { KeyValuePair } from 'helpers';
import axios from 'axios';

let EditOrder = () => {
    let service = useContext(orderContext);
    let appService = useContext(applicationContext);

    type Order = yup.InferType<typeof orderSchema>;

    let [open, setOpen] = useState(false);

    let [counties, setCounties] = useState<KeyValuePair<string, string>[]>([]);
    let [orderData, setOrderData] = useState<Order>({
        ...orderSchema.getDefault(),

        id: service.order.id,
        billingCountryCode: service.order.billingAddress.countryCode,
        billingCity: service.order.billingAddress.city,
        billingPostalCode: service.order.billingAddress.postalCode,
        billingVatNumber: service.order.billingAddress.vatNumber,
        billingFirstName: service.order.billingAddress.firstName,
        billingLastName: service.order.billingAddress.lastName,
        billingAddressLine1: service.order.billingAddress.addressLine1,
        billingAddressLine2: service.order.billingAddress.addressLine2,
        billingAddressPhoneNumber: service.order.billingAddress.phoneNumber,

        shippingCountryCode: appService.referenceData.DueCountry.findIndex(x => x.key === service.order.shippingAddress.countryCode) !== -1
            ? service.order.shippingAddress.countryCode
            : '',
        shippingCity: service.order.shippingAddress.city,
        shippingPostalCode: service.order.shippingAddress.postalCode,
        shippingState: service.order.shippingAddress.state,
        shippingFirstName: service.order.shippingAddress.firstName,
        shippingLastName: service.order.shippingAddress.lastName,
        shippingAddressLine1: service.order.shippingAddress.addressLine1,
        shippingAddressLine2: service.order.shippingAddress.addressLine2,
        ShippingAddressPhoneNumber: service.order.shippingAddress.phoneNumber,

        firstName: service.order.customer.firstName,
        lastName: service.order.customer.lastName
    } as Order)

    let prepareDialog = async () => {

        try {
            let res = await axios.get('/api/County/GetCounties');

            let { items } = res.data;
            setCounties(items);

            setOrderData({
                ...orderData,
                shippingStateCode: items.findIndex((x: KeyValuePair<string, string>) => x.key === service.order.shippingAddress.stateCode) !== -1
                    ? service.order.shippingAddress.stateCode
                    : '',
            })
        } catch (err) { }

        setOpen(true);
    }


    return (
        <>
            <Button
                variant='contained'
                onClick={async () => await prepareDialog()}
            >
                Edit
            </Button>
            {open === true &&
                <Dialog
                    open={open}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>Edit order {service.order.orderId}</DialogTitle>
                    <Formik
                        initialValues={orderData}
                        validationSchema={orderSchema}
                        onSubmit={(values, action) => {
                            service.saveOrder(values);
                            action.setSubmitting(false);;
                        }}
                    >
                        {formProps =>
                            <Form>
                                <DialogContent>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant='h6'>Billing address</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='billingFirstName'
                                                fullWidth
                                                size='small'
                                                label='First name'
                                                disabled={service.order.canEditBillingAndCustomerName === false}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='billingLastName'
                                                fullWidth
                                                size='small'
                                                label='Last name'
                                                disabled={service.order.canEditBillingAndCustomerName === false}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='billingAddressLine1'
                                                fullWidth
                                                size='small'
                                                label='Address line 1'
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='billingAddressLine2'
                                                fullWidth
                                                size='small'
                                                label='Address line 2'
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                label="Phone number"
                                                name='billingAddressPhoneNumber'
                                                fullWidth
                                                size='small'
                                            >
                                            </Field>
                                        </Grid>
                                        <Grid item xs={6} />
                                        <Grid item xs={3}>
                                            <Field
                                                component={TextField}
                                                name='billingPostalCode'
                                                fullWidth
                                                size='small'
                                                label='Postal code'
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Field
                                                component={TextField}
                                                name='billingCity'
                                                fullWidth
                                                size='small'
                                                label='City'
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Field
                                                name="billingCountryCode"
                                                component={Autocomplete}
                                                disableClearable
                                                options={appService.referenceData.DueCountry.map(x => x.key)}
                                                getOptionSelected={(option: string, value: string) => option === value}
                                                getOptionLabel={(option: string) => `${appService.referenceData.DueCountry.getValueByKey(option)} (${option})`}
                                                renderInput={(params: any) =>
                                                    <MuiTextField
                                                        {...params}
                                                        size="small"
                                                        error={formProps.touched['billingCountryCode'] && !!formProps.errors['billingCountryCode']}
                                                        helperText={formProps.errors['billingCountryCode']}
                                                        label="Country"
                                                    />
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Field
                                                component={TextField}
                                                name='billingVatNumber'
                                                fullWidth
                                                size='small'
                                                label='Vat number'
                                            />
                                        </Grid>
                                        <Grid item xs={4} />
                                        <Grid item xs style={{ paddingTop: theme.spacing(1) }}>
                                            <Typography>Current value: {service.order.billingAddress.countryCode}</Typography>
                                        </Grid>
                                        <Grid item xs style={{ paddingTop: theme.spacing(1) }}>
                                            <Typography>Current value: {service.order.billingAddress.vatNumber}</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Typography variant='h6'>Shipping address</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='shippingFirstName'
                                                fullWidth
                                                size='small'
                                                label='First name'
                                                disabled={service.order.canEditShippingName === false}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='shippingLastName'
                                                fullWidth
                                                size='small'
                                                label='Last name'
                                                disabled={service.order.canEditShippingName === false}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='shippingAddressLine1'
                                                fullWidth
                                                size='small'
                                                label='Address line 1'
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='shippingAddressLine2'
                                                fullWidth
                                                size='small'
                                                label='Address line 2'
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                label="Phone number"
                                                name='ShippingAddressPhoneNumber'
                                                fullWidth
                                                size='small'
                                            >
                                            </Field>
                                        </Grid>
                                        <Grid item xs={6} />
                                        <Grid item xs={3}>
                                            <Field
                                                component={TextField}
                                                name='shippingPostalCode'
                                                fullWidth
                                                size='small'
                                                label='Postal code'
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Field
                                                component={TextField}
                                                name='shippingCity'
                                                fullWidth
                                                size='small'
                                                label='City'
                                            />
                                        </Grid>
                                        {formProps.values.shippingCountryCode === "IT" &&
                                            <Grid item xs={3}>
                                                <Field
                                                    component={TextField}
                                                    label="State code"
                                                    name='shippingStateCode'
                                                    fullWidth
                                                    size='small'
                                                    select
                                                    onChange={(e: any) => {
                                                        formProps.setFieldValue('shippingStateCode', e.target.value);
                                                        formProps.setFieldValue('shippingState', counties.find(x => x.key === e.target.value)?.value);
                                                    }}
                                                >
                                                    <MenuItem key={''} value={''}></MenuItem>
                                                    {counties.map((county) =>
                                                        <MenuItem key={county.key} value={county.key}>{county.value}</MenuItem>
                                                    )}
                                                </Field>
                                            </Grid>
                                        }
                                        <Grid item xs={3}>
                                            <Field
                                                name="shippingCountryCode"
                                                component={Autocomplete}
                                                disableClearable
                                                options={appService.referenceData.DueCountry.map(x => x.key)}
                                                getOptionSelected={(option: string, value: string) => option === value}
                                                getOptionLabel={(option: string) => `${appService.referenceData.DueCountry.getValueByKey(option)} (${option})`}
                                                renderInput={(params: any) =>
                                                    <MuiTextField
                                                        {...params}
                                                        size="small"
                                                        error={formProps.touched['shippingCountryCode'] && !!formProps.errors['shippingCountryCode']}
                                                        helperText={formProps.errors['shippingCountryCode']}
                                                        label="Country"
                                                    />
                                                }
                                            />
                                        </Grid>
                                        {formProps.values.shippingCountryCode !== "IT" &&
                                            <Grid item xs={4} />
                                        }
                                        <Grid item xs={4} />
                                        {formProps.values.shippingCountryCode === "IT" &&
                                            <Grid item xs={4} style={{ paddingTop: theme.spacing(1) }}>
                                                <Typography>Current value: {service.order.shippingAddress.stateCode}</Typography>
                                            </Grid>
                                        }
                                        <Grid item xs={4} style={{ paddingTop: theme.spacing(1) }}>
                                            <Typography>Current value: {service.order.shippingAddress.countryCode}</Typography>
                                        </Grid>
                                        
                                        <Grid item xs={12}>
                                            <Typography variant='h6'>Customer</Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='firstName'
                                                fullWidth
                                                size='small'
                                                label='First name'
                                                disabled={service.order.canEditBillingAndCustomerName === false}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Field
                                                component={TextField}
                                                name='lastName'
                                                fullWidth
                                                size='small'
                                                label='Last name'
                                                disabled={service.order.canEditBillingAndCustomerName === false}
                                            />
                                        </Grid>
                                    </Grid>
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        variant='outlined'
                                        onClick={() => setOpen(false)}
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                    >
                                        Save
                                    </Button>
                                </DialogActions>
                            </Form>
                        }
                    </Formik >
                </Dialog >
            }
        </>
    );
}

export default EditOrder;